import React, { useState, useEffect } from "react";
import axios from "axios";
import API_URL from "../config";

const ColorFondoServiciosAdmin = () => {
  const [servicios, setServicios] = useState([]);
  const [loading, setLoading] = useState(false);

  const [niveles, setNiveles] = useState([]);
  const [loadingNiveles, setLoadingNiveles] = useState(false);

  // Cargar servicios al montar el componente
  useEffect(() => {
    cargarServicios();
    cargarNiveles();
  }, []);

  const cargarServicios = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/servicios`);

      setServicios(res.data);
    } catch (error) {
      console.error("Error cargando servicios", error);
      alert("❌ No se pudieron cargar los servicios");
    }
  };

  const cargarNiveles = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/niveles`);
      setNiveles(res.data);
    } catch (error) {
      console.error("Error cargando niveles", error);
      alert("❌ No se pudieron cargar las secciones");
    }
  };

  // Cambiar color de sección en el estado local
  const cambiarColorNivel = (id, nuevoColor) => {
    setNiveles((prev) =>
      prev.map((n) => (n.id === id ? { ...n, color: nuevoColor } : n))
    );
  };

  // Activar/desactivar difuminado de una sección en el estado local
  const cambiarDifuminadoNivel = (id, activo) => {
    setNiveles((prev) =>
      prev.map((n) => (n.id === id ? { ...n, color_difuminado: activo } : n))
    );
  };

  // Guardar colores de secciones
  const guardarColoresNiveles = async () => {
    try {
      setLoadingNiveles(true);

      const promesas = niveles.map((nivel) =>
        axios.post(`${API_URL}/api/niveles/${nivel.id}/color`, {
          color: nivel.color || "#38bdf8",
          color_difuminado: !!nivel.color_difuminado,
        })
      );

      await Promise.all(promesas);

      alert("🎨 Colores de secciones actualizados correctamente!");
    } catch (error) {
      console.error("Error guardando colores de secciones", error);
      alert("❌ Error al guardar los cambios");
    } finally {
      setLoadingNiveles(false);
    }
  };

  // Cambiar color en el estado local
  const cambiarColor = (id, nuevoColor) => {
    const nuevosServicios = servicios.map((s) =>
      s.id === id ? { ...s, color_fondo: nuevoColor } : s
    );
    setServicios(nuevosServicios);
  };

  // Activar/desactivar el difuminado (degradado hacia blanco) en el estado local
  const cambiarDifuminado = (id, activo) => {
    const nuevosServicios = servicios.map((s) =>
      s.id === id ? { ...s, fondo_difuminado: activo } : s
    );
    setServicios(nuevosServicios);
  };

  // Guardar cambios en la base de datos
  const guardarCambios = async () => {
    try {
      setLoading(true);

      const promesas = servicios.map((servicio) =>
        axios.post(
          `${API_URL}/api/servicios/${servicio.id}/color_fondo`,
          {
            color_fondo: servicio.color_fondo || "#ffffff",
            fondo_difuminado: !!servicio.fondo_difuminado,
          }
        )
      );

      await Promise.all(promesas);

      alert("🎨 Fondos de servicios actualizados correctamente!");
    } catch (error) {
      console.error("Error guardando colores", error);
      alert("❌ Error al guardar los cambios");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "#f0f4ff",
        padding: "30px",
        borderRadius: "12px",
        maxWidth: "600px",
        margin: "20px auto",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "25px",
          color: "#1e3a8a",
        }}
      >
        Fondos por Servicio
      </h2>

      {servicios.map((servicio) => (
        <div
          key={servicio.id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "15px",
            background: "white",
            padding: "10px 15px",
            borderRadius: "8px",
          }}
        >
          <span style={{ fontWeight: "600" }}>
            {servicio.nombre}
          </span>

          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <input
              type="color"
              value={servicio.color_fondo || "#ffffff"}
              onChange={(e) =>
                cambiarColor(servicio.id, e.target.value)
              }
            />
            <input
              type="text"
              value={servicio.color_fondo || "#ffffff"}
              onChange={(e) =>
                cambiarColor(servicio.id, e.target.value)
              }
              style={{
                fontFamily: "monospace",
                fontSize: 13,
                padding: "4px 8px",
                borderRadius: 6,
                border: "1px solid #cbd5e1",
                width: 90,
              }}
            />
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
                fontSize: 13,
                color: "#475569",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              <input
                type="checkbox"
                checked={!!servicio.fondo_difuminado}
                onChange={(e) => cambiarDifuminado(servicio.id, e.target.checked)}
              />
              Difuminado
            </label>
          </div>
        </div>
      ))}

      <div
        style={{
          textAlign: "center",
          marginTop: "20px",
        }}
      >
        <button
          onClick={guardarCambios}
          disabled={loading}
          style={{
            padding: "10px 25px",
            background: "#2563eb",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          {loading ? "Guardando..." : "Guardar cambios"}
        </button>
      </div>

      <h2
        style={{
          textAlign: "center",
          margin: "35px 0 25px",
          color: "#1e3a8a",
        }}
      >
        Fondo de Servicio CDA — Secciones
      </h2>

      {niveles.map((nivel) => (
        <div
          key={nivel.id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "15px",
            background: "white",
            padding: "10px 15px",
            borderRadius: "8px",
          }}
        >
          <span style={{ fontWeight: "600" }}>
            {nivel.nombre}
          </span>

          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <input
              type="color"
              value={nivel.color || "#38bdf8"}
              onChange={(e) =>
                cambiarColorNivel(nivel.id, e.target.value)
              }
            />
            <input
              type="text"
              value={nivel.color || "#38bdf8"}
              onChange={(e) =>
                cambiarColorNivel(nivel.id, e.target.value)
              }
              style={{
                fontFamily: "monospace",
                fontSize: 13,
                padding: "4px 8px",
                borderRadius: 6,
                border: "1px solid #cbd5e1",
                width: 90,
              }}
            />
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
                fontSize: 13,
                color: "#475569",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              <input
                type="checkbox"
                checked={!!nivel.color_difuminado}
                onChange={(e) => cambiarDifuminadoNivel(nivel.id, e.target.checked)}
              />
              Difuminado
            </label>
          </div>
        </div>
      ))}

      <div
        style={{
          textAlign: "center",
          marginTop: "20px",
        }}
      >
        <button
          onClick={guardarColoresNiveles}
          disabled={loadingNiveles}
          style={{
            padding: "10px 25px",
            background: "#2563eb",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          {loadingNiveles ? "Guardando..." : "Guardar colores de secciones"}
        </button>
      </div>
    </div>
  );
};

export default ColorFondoServiciosAdmin;